













































import { Component, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';
import { BusEvent } from '@/models/bus';

import Module from '@/api/module';
import Topic from '@/api/topic';
import ApiList from '@/api/list';
import Category from '@/api/category';

import ArrowIcon from '@/components/icons/ArrowIcon.vue';
import ListProject from '@/components/listView/ListProject.vue';
import EditModule from '@/editComponents/EditModule.vue';
import EditProject from '@/editComponents/EditProject.vue';
import Project from '@/api/project';
@Component({
  components: {
    'list-project': ListProject,
    'arrow-icon': ArrowIcon,
    'edit-module': EditModule,
    'edit-project': EditProject,
  },
})
export default class EntityView extends CommonVue {
  @Prop({ type: String }) public entity!: string;
  @Prop() public id: number;
  @Prop({ type: Boolean, default: false }) public isEdit!: boolean;

  public projects?: Promise<ApiList<Project>> = undefined;
  
  public list?:
    | Promise<ApiList<Module>>
    | Promise<ApiList<Category>> = undefined;

  public beforeMount() {
    this.getList();

    this.$bus.$on(BusEvent.CACHE_CHANGED, () => {
      this.getList();
    });
  }

  @Watch('entity')
  public getList() {
    console.log('this.entity', this.entity);
    switch (this.entity) {
      case this.PROJECT_SLUG:
        this.list = Module.listAll();
        this.projects = Project.list();
        break;
      default:
        this.list = Topic.listAll();
    }
  }
}
